import React from "react";
import Brands from "./Brands/Brands";
import Header from "./Header/Header";
import Services from "./Services/Services";

function About() {
  return (
    <div>
      <Header />
      <Services />
      <Brands />
    </div>
  );
}

export default About;
